import {
    GET_ALL_STRENGTH_BEGIN,
    GET_ALL_STRENGTH_SUCCESS,
    GET_ALL_STRENGTH_ERROR,
    ADD_STRENGTH_BEGIN,
    ADD_STRENGTH_SUCCESS,
    ADD_STRENGTH_ERROR,
    GET_STRENGTH_BEGIN,
    GET_STRENGTH_ERROR,
    GET_STRENGTH_SUCCESS,
    UPDATE_STRENGTH_BEGIN,
    UPDATE_STRENGTH_SUCCESS,
    UPDATE_STRENGTH_ERROR,
    DELETE_STRENGTH_BEGIN,
    DELETE_STRENGTH_SUCCESS,
    DELETE_STRENGTH_ERROR,
  } from "./constants";
  
  const initState = {
    list: [],
    loading: false,
    error: null,
  };
  
  const StrengthReducer = (state = initState, action) => {
    const { type, data, error } = action;
    switch (type) {
      case GET_ALL_STRENGTH_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case GET_ALL_STRENGTH_SUCCESS:
        return {
          ...state,
          list: data,
          loading: false,
        };
      case GET_ALL_STRENGTH_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case ADD_STRENGTH_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case ADD_STRENGTH_SUCCESS:
        return {
          ...state,
          loading: false,
          list: [...state.list, data],
        };
      case ADD_STRENGTH_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case GET_STRENGTH_BEGIN:
        return {
          ...state,
          loading: true,
          strengthData: "",
        };
      case GET_STRENGTH_SUCCESS:
        return {
          ...state,
          loading: false,
          strengthData: data,
        };
      case GET_STRENGTH_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case UPDATE_STRENGTH_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case UPDATE_STRENGTH_SUCCESS:
        return {
          ...state,
          loading: false,
          list: state.list.map((ele) => {
            if (ele.id === data.id) {
              return { ...data };
            } else return ele;
          }),
        };
      case UPDATE_STRENGTH_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case DELETE_STRENGTH_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case DELETE_STRENGTH_SUCCESS:
        return {
          ...state,
          loading: false,
          list: state.list.filter((ele) => ele.id !== data.id),
        };
      case DELETE_STRENGTH_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      default:
        return state;
    }
  };
  
  export default StrengthReducer;
  